export const soundLightAlarmConfigDefault = {
  alarmLevel: 3,
  alarmCycle: 0,
  alarmInterval: 60,
  alarmDuration: 10
}
